module.exports = __webpack_public_path__ + "img/checkmark_green_default.d296909c.svg";